export function isAbsolute(url: string): boolean {
    return /^(?:https?:)?\/\//i.test(url);
}
